const FONT_SIZE_MULTIPLIER = 4;

const IMAGE_PX_WIDTH_33 = 2334; // 197.6mm en 300dpi
const IMAGE_PX_HEIGHT_33 = 1346; // 114mm en 300dpi
const IMAGE_WIDTH_33 = 197.6; // mm
const IMAGE_HEIGHT_33 = 114; // mm

const IMAGE_PX_WIDTH_50 = 2458; // 208.1mm en 300dpi
const IMAGE_PX_HEIGHT_50 = 1835; // 155.4mm en 300dpi
const IMAGE_WIDTH_50 = 208.1; // mm
const IMAGE_HEIGHT_50 = 155.4; // mm

const BAT_SCALE_FACTOR = 1;
const BAT_DPI = 300 * BAT_SCALE_FACTOR;
const WARNING_MINIMUM_DPI = 150;
const FABRIC_CONTROL_COLOR = '#4467f1';
const GRADUATION_NAME = 'GRADUATION';

const CUTTING_PATH_SELECTION_OPACITY = 0.75;
const CUTTING_PATH_DEFAULT_OPACITY = 1;

const BACKGROUND_MASK_SELECTION_OPACITY = 0;
const BACKGROUND_MASK_DEFAULT_OPACITY = 1;

const MASK_MARGIN_PX = 2;

export {
    BACKGROUND_MASK_DEFAULT_OPACITY,
    BACKGROUND_MASK_SELECTION_OPACITY,
    BAT_DPI,
    BAT_SCALE_FACTOR,
    CUTTING_PATH_DEFAULT_OPACITY,
    CUTTING_PATH_SELECTION_OPACITY,
    FABRIC_CONTROL_COLOR,
    FONT_SIZE_MULTIPLIER,
    GRADUATION_NAME,
    IMAGE_HEIGHT_33,
    IMAGE_HEIGHT_50,
    IMAGE_PX_HEIGHT_33,
    IMAGE_PX_HEIGHT_50,
    IMAGE_PX_WIDTH_33,
    IMAGE_PX_WIDTH_50,
    IMAGE_WIDTH_33,
    IMAGE_WIDTH_50,
    MASK_MARGIN_PX,
    WARNING_MINIMUM_DPI,
};
